import type { StreamStatus } from "../../../../../stream";
import type { ScoutActiveTurn, ScoutTurnStatus } from "../../hooks/types";
import type { ScoutChatMessage } from "./scoutChatMessage";

export const SCOUT_ASSISTANT_MESSAGE_ID_PREFIX = "scout-assistant-";

/** Turn statuses where the current assistant message UI should stay suppressed. */
export const AGENT_TURN_IN_PROGRESS_STATUSES = new Set<ScoutTurnStatus>([
  "starting",
  "streaming",
  "error",
  "aborted",
]);

export function getScoutAssistantMessageId(requestId: string): string {
  return `${SCOUT_ASSISTANT_MESSAGE_ID_PREFIX}${requestId}`;
}

export function isCurrentActiveAssistantMessage(
  message: ScoutChatMessage,
  activeTurn: ScoutActiveTurn
): boolean {
  return message.id === getScoutAssistantMessageId(activeTurn.requestId);
}

export function shouldSuppressAgentMessageToolbar(input: {
  message: ScoutChatMessage;
  activeTurn?: ScoutActiveTurn;
  streamStatus?: StreamStatus;
}): boolean {
  if (input.message.isStreaming) {
    return true;
  }

  if (input.activeTurn && isCurrentActiveAssistantMessage(input.message, input.activeTurn)) {
    if (AGENT_TURN_IN_PROGRESS_STATUSES.has(input.activeTurn.status)) {
      return true;
    }

    if (input.streamStatus === "error") {
      return true;
    }
  }

  return false;
}

/** True when the agent turn is finished enough to show post-turn UI (opt-in, etc.). */
export function isCurrentAgentTurnComplete(input: {
  activeTurn?: ScoutActiveTurn;
  streamStatus?: StreamStatus;
  messages: ScoutChatMessage[];
}): boolean {
  if (input.messages.some((message) => message.role === "assistant" && message.isStreaming)) {
    return false;
  }

  if (!input.activeTurn) {
    return true;
  }

  if (AGENT_TURN_IN_PROGRESS_STATUSES.has(input.activeTurn.status)) {
    return false;
  }

  if (input.streamStatus === "error") {
    return false;
  }

  return true;
}
